import { Injectable } from "@angular/core";
import { IScrapedData } from "@ehrSharedResources/models/scraped-data.model";
import { Subject } from "rxjs";
import { LocalStorageHandlerService } from "../local-storage-handler/local-storage-handler.service";
import { RouteHandlerService } from "@ehrCore/services/route-handler/route-handler.service";
import { take } from "rxjs/operators";
import { SessionService } from "src/app/session/session.service";
import { CookieService } from "ngx-cookie";
import { ExtensionMessagePublisherService } from "../extension-message-publisher/extension-message-publisher.service";

@Injectable({
  providedIn: "root"
})
export class ExtensionMessageSubscriberService {

  constructor(
    private localStorageHandler: LocalStorageHandlerService,
    private routeHandlerService: RouteHandlerService,
    private sessionService: SessionService,
    private cookieService: CookieService,
    private extensionMessagePublisherService: ExtensionMessagePublisherService
  ) { }

  private _data: IScrapedData = null;
  private _scrapedData$ = new Subject<IScrapedData>();

  set data(data: IScrapedData) {
    this.localStorageHandler.setScrapedDataValue(data);
    this._data = data;
  }

  get data(): IScrapedData {
    return this._data;
  }

  processAthenaData(data: IScrapedData) {
    this.data = data;
    const userDetails = JSON.parse(this.localStorageHandler.getUserDetailsValue());
    this.routeHandlerService.process({
      userDetails,
      scrapedData: this.data
    });
    this.publishScrapedData();
  }

  publishScrapedData() {
    this._scrapedData$.next(this.data);
  }

  logout() {
    this.sessionService.logOut().pipe(
      take(1)
    ).subscribe(() => {
      this.localStorageHandler.clearAllValues();
      sessionStorage.clear();
      this.cookieService.removeAll();
      this.extensionMessagePublisherService.publishLogoutSuccess();
    });
  }

  subscribeToScrapedData() {
    return this._scrapedData$.asObservable();
  }

}
